import { Exclude, Type } from 'class-transformer';
import { DimensionOptionResultDto } from '../../common/dimensions/dimension-option-result-dto';

export class ARCreditApplicationTransactionItemResultDto {
    id: number; // sourceId / targetId
    itemId: number; // sourceLineItemId / targetLineItemId
    amount: number;
    openBalance: number;
    glAccountNumber: string;
    offsetGLAccountNumber: string;
    description: string;
    @Type(() => DimensionOptionResultDto)
    dimensions: DimensionOptionResultDto[];

    // Transient variable
    @Exclude()
    appliedAmount: number;
    @Exclude()
    isSelect = false;
    @Exclude()
    targetItems: Array<ARCreditApplicationTransactionItemResultDto>; //// why do we need targetItems
    @Exclude()
    sourceItemId: number; // this is used to get the exact source item from creditApplicationSourceLineItems
    @Exclude()
    remainingOpenBalance: number;
    @Exclude()
    currentAppliedAmount: number;
}
